<template>
  <div class="grid-9 grid-column-gap-0">
    <div class="sidebar-wrapper span-2">
      <slot />
    </div>
    <div class="span-7 span-9-sm span-9-md p-20" style="border-left: 1px solid black">
      <div class="page-header--wrapper clear mb-20">
        <headline class="mb-20" :title="'Hero'" />
        <edit-hero />
      </div>
      <div class="page-header--wrapper clear mb-20">
        <headline class="mb-20" :title="'Featured Collections'" />
        <edit-features />
      </div>
      <div class="page-header--wrapper clear mb-20">
        <headline class="mb-20" :title="'New arrivals'" />
        <edit-featured-brands />
      </div>
      <div class="page-header--wrapper clear mb-20">
        <headline class="mb-20" :title="'Best Sellers'" />
        <edit-best-sellers />
      </div>
      <div class="page-header--wrapper clear mb-20">
        <edit-perfect-for-the />
      </div>
      <div class="page-header--wrapper clear mb-20">
        <headline class="mb-20" :title="'About'" />
        <edit-about />
      </div>
    </div>
  </div>
</template>

<script>
import EditFeatures from "./editFeatures/editFeatures.vue";
import EditHero from "./editHero/editHero.vue";
import EditFeaturedBrands from "./editFeaturedBrands/editFeaturedBrands.vue";
import EditBestSellers from "./editBestSellers/editBestSellers.vue";
import EditAbout from "./editAbout/editAbout.vue";
import EditPerfectForThe from "./editPerfectForThe/editPerfectForThe.vue";

export default {
  components: {
    EditHero,
    EditFeatures,
    EditFeaturedBrands,
    EditBestSellers,
    EditAbout,
    EditPerfectForThe,
  },
};
</script>
